<template>
  <div class="page-box">
    <base-screen>
      <a-form-model ref="formRef" layout="inline" :model="queryRef" @submit="handleSearch" @submit.native.prevent>
        <a-form-model-item label="用户昵称" prop="userName">
          <a-input v-model="queryRef.userName" placeholder="请输入" />
        </a-form-model-item>
        <a-form-model-item label="手机号" prop="userPhone">
          <a-input v-model="queryRef.userPhone" placeholder="请输入" />
        </a-form-model-item>
        <a-form-model-item label="状态" prop="state">
          <a-select style="width: 120px" placeholder="请选择" v-model='queryRef.state' allowClear>
            <a-select-option :value="1">正常</a-select-option>
            <a-select-option :value="-1">禁用</a-select-option>
            <a-select-option :value="-2">冻结</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item>
          <a-button type="primary" @click="handleSearch">查询</a-button>
          <a-button @click="handleReset">重置</a-button>
        </a-form-model-item>
      </a-form-model>
    </base-screen>

    <a-table
      :rowKey="(record,index) => record.userCommissionId"
      :data-source="tableData"
      :loading='loading'
      :columns="columns"
      :pagination="pagination"
      @change='tableChange'
    >
      <template slot='user' slot-scope="text, record">
        <div class="user-card">
          <img v-if="record.headImg" :src="record.headImg" alt="" />
          <p>{{record.userName}}</p>
        </div>
      </template>
      <template slot='state' slot-scope="text, record">
        <a-tag :color="getStateColor(record.state)">{{ getStateText(record.state) }}</a-tag>
      </template>
      <template slot='operation' slot-scope="text, record">
        <a-button type="link" @click='editState(record)'>修改状态</a-button>
      </template>
    </a-table>

    <a-modal v-model="showModal" title='修改状态' :confirm-loading="confirmLoading" @ok='submit' @cancel='cancel'>
      <a-form-model ref="modalFormRef" :model="form" :rules="rules" :label-col="{span:6}" :wrapper-col="{span: 18}">
        <a-form-model-item label="当前状态">
          <a-tag :color="getStateColor(currentRecord.state)">{{ getStateText(currentRecord.state) }}</a-tag>
        </a-form-model-item>
        <a-form-model-item label="新状态" prop="state">
          <a-radio-group v-model='form.state'>
            <a-radio :value="1">正常</a-radio>
            <a-radio :value="-1">禁用</a-radio>
            <a-radio :value="-2">冻结</a-radio>
          </a-radio-group>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
import { agent } from '@/api'
import { getSession } from '@/utils/session'
import { SHOPID } from '@/constants'
export default {
  name: 'PageUserCommission',
  data () {
    return {
      loading: false,
      queryRef: {
        userName: '',
        userPhone: '',
        state: undefined,
      },
      showModal: false,
      confirmLoading: false,
      form: {
        state: 1
      },
      currentRecord: {},
      tableData: [],
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
      },
      rules: {
        state: [{ required: true, message: '请选择状态' }]
      },
      columns: [
        {
          title: '用户',
          scopedSlots: {
            customRender: 'user'
          }
        },
        {
          title: '手机号',
          dataIndex: 'userPhone'
        },
        {
          title: '总佣金',
          dataIndex: 'amount'
        },
        {
          title: '可提现',
          dataIndex: 'cashAmount'
        },
        {
          title: '待提现',
          dataIndex: 'unCashAmount'
        },
        {
          title: '状态',
          scopedSlots: {
            customRender: 'state'
          }
        },
        {
          title: '创建时间',
          dataIndex: 'createTime'
        },
        {
          title: '操作',
          scopedSlots: {
            customRender: 'operation'
          }
        }
      ]
    }
  },
  mounted () {
    this.getData()
  },
  methods: {
    getStateColor (state) {
      const colorMap = {
        1: 'green',
        '-1': 'red',
        '-2': 'orange'
      }
      return colorMap[state] || 'default'
    },
    getStateText (state) {
      const textMap = {
        1: '正常',
        '-1': '禁用',
        '-2': '冻结'
      }
      return textMap[state] || '未知'
    },
    async getData () {
      this.loading = true
      const { data, code, page, msg } = await agent.getUserCommissionPage({
        ...this.queryRef,
        current: this.pagination.current,
        size: this.pagination.pageSize,
      })
      this.loading = false
      if (code === '00000') {
        this.tableData = data
        this.pagination.current = page.pageNo
        this.pagination.pageSize = page.pageSize
        this.pagination.total = page.total
      } else {
        this.$message.error(msg || '获取数据失败')
      }
    },
    handleSearch () {
      this.pagination.current = 1
      this.getData()
    },
    handleReset () {
      this.$refs.formRef.resetFields()
      this.getData()
    },
    tableChange ({ current }) {
      this.pagination.current = current
      this.getData()
    },
    editState (record) {
      this.currentRecord = Object.assign({}, record)
      this.form.state = record.state
      this.showModal = true
    },
    async submit () {
      this.confirmLoading = true
      const { code, msg } = await agent.updateUserCommissionState({
        userId: this.currentRecord.userId,
        shopId: getSession(SHOPID),
        state: this.form.state
      })
      this.confirmLoading = false
      if (code === '00000') {
        this.showModal = false
        this.$message.success('修改成功')
        this.getData()
      } else {
        this.$message.error(msg || '操作失败')
      }
    },
    cancel () {
      this.showModal = false
      this.$refs.modalFormRef.resetFields()
    },
  }
}
</script>

<style lang="less" scoped>
.user-card {
  display: flex;
  align-items: center;
  img {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    margin-right: 8px;
  }
  p {
    margin: 0;
  }
}
</style>
